import { useState, useEffect, type JSX } from "react";
import { useTranslation } from "react-i18next";

import TableComponent, { TableHeader } from "../../components/TableComponent";
import { getCrews, Crew } from "../../api/crew";

import CrewItem from "./CrewItem";

const CrewsTable = (): JSX.Element => {
  const { t } = useTranslation();
  const [crews, setCrews] = useState<Crew[]>([]);

  useEffect(() => {
    getCrews().then(setCrews);
  }, []);

  const tableHeaders: TableHeader[] = [
    { title: t("id"), sort: "id", style: { width: "5%" } },
    { title: t("company_name"), sort: "companyName" },
    { title: t("contact_person"), sort: "contactPerson" },
    { title: t("contact_email"), sort: "email" },
    { title: t("contact_phone"), sort: "phone" },
    { title: t("status"), sort: "status" },
    { title: t("address"), sort: "address" },
    { title: t("postcode"), sort: "postcode" },
    { title: t("city"), sort: "city" },
  ];

  return (
    <>
      <h2>{t("companies")}</h2>
      <TableComponent
        header={tableHeaders}
        renderChildren={(crew: Crew) => <CrewItem key={crew.id} crew={crew} />}
        items={crews}
        search={["companyName", "id"]}
        pagination
      />
    </>
  );
};

export default CrewsTable;
